import { combineReducers } from "redux";
import PromiseReducer from "./PromiseReducer";
export default combineReducers({
  PromiseReducer
});
